import { RentalUnit } from './unit.data';

export interface StorageData extends RentalUnit {
  /** community only, never with shares */
  apartmentId?: string | null;
  landRegister?: string | null;
  type?: StorageType | null;
  staircaseNumber?: string | null;
  area: number;
}

export enum StorageType {
  STORAGE_ROOM = 'storage',
  BIKE_BOX = 'bicycle_box',
  TECHNICAL = 'technical_room',
  LOCKER = 'locker',
  OTHER = 'other'
}
